/**
 * [Gurumi 블록 메뉴]
 * 역할: yesmoney EditorBlockMenu 포팅
 * 작성/수정일: 2026-07-29
 */
import { iconSvg } from '../icons.js';
import { EDITOR_BLOCK_OPTIONS, applyEditorBlockType, getActiveEditorBlockType } from '../block-types.js';

export function createBlockMenu(editor, onStateChange) {
  const root = document.createElement('div');
  root.className = 'g5-gurumi-block-menu';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'g5-gurumi-block-btn';
  btn.setAttribute('aria-haspopup', 'menu');
  btn.setAttribute('aria-label', '텍스트 스타일');
  btn.innerHTML = '<span class="g5-gurumi-block-label" aria-hidden="true">가 <span class="g5-gurumi-block-label-sm">가</span></span>';
  btn.appendChild(iconSvg('chevronDown', 'g5-gurumi-icon g5-gurumi-icon-muted'));

  const menu = document.createElement('div');
  menu.className = 'g5-gurumi-block-dropdown';
  menu.setAttribute('role', 'menu');
  menu.hidden = true;

  EDITOR_BLOCK_OPTIONS.forEach((option) => {
    if (option.dividerBefore) {
      const div = document.createElement('div');
      div.className = 'g5-gurumi-block-divider';
      div.setAttribute('aria-hidden', 'true');
      menu.appendChild(div);
    }
    const item = document.createElement('button');
    item.type = 'button';
    item.className = 'g5-gurumi-block-item';
    item.setAttribute('role', 'menuitemradio');
    item.dataset.type = option.type;
    item.innerHTML = `
      <span class="g5-gurumi-block-check"></span>
      ${option.marker ? `<span class="g5-gurumi-block-marker">${option.marker}</span>` : ''}
      <span class="g5-gurumi-block-item-label ${option.previewClass || ''}">${option.label}</span>
    `;
    item.addEventListener('click', () => {
      applyEditorBlockType(editor, option.type);
      close();
      onStateChange?.();
    });
    menu.appendChild(item);
  });

  function refreshActive() {
    const active = getActiveEditorBlockType(editor);
    menu.querySelectorAll('.g5-gurumi-block-item').forEach((el) => {
      const selected = el.dataset.type === active;
      el.setAttribute('aria-checked', selected ? 'true' : 'false');
      el.classList.toggle('is-active', selected);
      const check = el.querySelector('.g5-gurumi-block-check');
      if (check) check.innerHTML = selected ? '' : '';
      if (check && selected) check.appendChild(iconSvg('check'));
    });
  }

  function open() {
    refreshActive();
    menu.hidden = false;
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
  }

  function close() {
    menu.hidden = true;
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  }

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (menu.hidden) open();
    else close();
  });

  document.addEventListener('mousedown', (e) => {
    if (!root.contains(e.target)) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  root.appendChild(btn);
  root.appendChild(menu);

  return { root, refreshActive, close };
}
